import type { PaginationData } from 'models';
import type { InfiniteData } from 'query';
import { useMemo } from 'react';
import type { NodeTodo, Todo } from '../../../../types';

export const useGetNumberOfTodos = ({
  featuredTodos,
  nodeTodos,
  todos,
}: {
  featuredTodos?: InfiniteData<PaginationData<Todo>>;
  nodeTodos?: InfiniteData<PaginationData<NodeTodo>>;
  todos?: InfiniteData<PaginationData<Todo>>;
}) =>
  useMemo(() => {
    const numberOfFeaturedTodos = featuredTodos?.pages.at(-1)?.total;
    const numberOfTodos = todos?.pages.at(-1)?.total;
    const numberOfNodeTodos = nodeTodos?.pages.at(-1)?.total;

    return numberOfFeaturedTodos === undefined || numberOfTodos === undefined || numberOfNodeTodos === undefined
      ? undefined
      : numberOfFeaturedTodos + numberOfTodos + numberOfNodeTodos;
  }, [featuredTodos, nodeTodos, todos]);
